
    const deathCoverPriceLabelFunction = (frequency) => {

     switch (Number(frequency)) {
       case 1:
           return "per annum"

       case 2:
           return "per half year"

       case 3:
           return "per quarter"

       case 4:
           return "per month"

   }
 }

 export default deathCoverPriceLabelFunction